import { Menu } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import LanguageSelector from '../ui/LanguageSelector'

interface HeaderProps {
  onMenuClick: () => void
  title?: string
}

export default function Header({ onMenuClick, title }: HeaderProps) {
  const { t } = useTranslation()

  return (
    <header className="pt-6 pb-6 px-4 flex items-center bg-white z-10 relative">
      <button
        onClick={onMenuClick}
        className="lg:hidden text-gray-500 hover:text-gray-800"
        aria-label={t('header.toggleMenu')}
      >
        <Menu className="w-6 h-6" />
      </button>
      <h1 className="absolute left-1/2 -translate-x-1/2 text-lg font-semibold text-primary-600 truncate max-w-lg">
        {title || t('chat.newChat')}
      </h1>
      <div className="ml-auto">
        <LanguageSelector />
      </div>
      <div className="absolute left-0 right-0 top-full h-4 bg-gradient-to-b from-white to-transparent pointer-events-none" />
    </header>
  )
}
